import './styles.scss';
import { Button } from '../../../ui-core';
import { withTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { creditCardSchema } from './creditCard.schema';
import NumberFormat from 'react-number-format';

import {
    attachPaymentMethod,
    detachPaymentMethod,
    getApiKey,
} from '../../../../services/api/paymentService/paymentService';
import { errorHandler, successHandler } from '../../../toastify/redux/notifyOperations';
import { StripeService } from '../../../../services/api/stripeService';
import { useDispatch } from 'react-redux';

const CardManagerModal = ({ t, data: { buttons, _id }, onClose }) => {
    const [isShowCv, setTsShowCvv] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch();

    const { handleSubmit, control, formState } = useForm({
        mode: 'onSubmit',
        defaultValues: {},
        resolver: yupResolver(creditCardSchema),
    });

    const handleFormSubmit = ({ cardNumber, cvv, date }) => {
        if (cardNumber && cvv && date) {
            if (isLoading) return
            setIsLoading(true)
            getApiKey()
                .then(({ publicKey }) => {
                    new StripeService()
                        .createPaymentMethod(publicKey, {
                            number: cardNumber.split(' ').join(''),
                            cvc: cvv,
                            exp_month: date.split('/')[0],
                            exp_year: date.split('/')[1],
                        })
                        .then(({ data: { id } }) => {
                            attachPaymentMethod(id)
                                .then(() => {
                                    detachPaymentMethod(_id)
                                        .then(() => {
                                            setIsLoading(false)
                                            window.location.reload();
                                        })
                                        .catch(error => { dispatch(errorHandler(error)); setIsLoading(false) });
                                })
                                .catch(error => { dispatch(errorHandler(error)); setIsLoading(false) });
                        })
                        .catch(error => { dispatch(errorHandler(error?.response?.data?.error?.message)); setIsLoading(false) });
                })
                .catch(error => { dispatch(errorHandler(error)); setIsLoading(false) });
        }
    };

    return (
        <div className="modal_default-modal">
            <form className="modal_credit-card" onSubmit={handleSubmit(handleFormSubmit)}>
                <label className="modal_credit-card__item credit-card__item-card">
                    <p className="modal_credit-card__item-label">{t('paymentPage-card')}</p>
                    <Controller
                        control={control}
                        name="cardNumber"
                        render={({ field: { onChange, name, value } }) => (
                            <NumberFormat
                                className="modal_credit-card__item-input"
                                onChange={onChange}
                                name={name}
                                value={value}
                                format="#### #### #### ####"
                                placeholder={'**** **** **** ****'}
                            />
                        )}
                    />
                    {formState?.errors?.cardNumber?.message ? (
                        <p className="modal_credit-card__item-error">{formState?.errors?.cardNumber?.message}</p>
                    ) : null}
                </label>

                <div className="modal_credit-card__container">
                    <label className="modal_credit-card__item">
                        <p className="modal_credit-card__item-label">{t('paymentPage-date')}</p>
                        <Controller
                            control={control}
                            name="date"
                            render={({ field: { onChange, name, value } }) => (
                                <NumberFormat
                                    className="modal_credit-card__item-input"
                                    onChange={onChange}
                                    name={name}
                                    value={value}
                                    format="##/##"
                                    placeholder="MM/YY"
                                    mask={['M', 'M', 'Y', 'Y']}
                                />
                            )}
                        />
                        {formState?.errors?.date?.message ? (
                            <p className="modal_credit-card__item-error">{formState?.errors?.date?.message}</p>
                        ) : null}
                    </label>

                    <label className="modal_credit-card__item">
                        <p className="modal_credit-card__item-label">{t('paymentPage-cvv')}</p>
                        <Controller
                            control={control}
                            name="cvv"
                            render={({ field: { onChange, name, value } }) => (
                                <input
                                    className="modal_credit-card__item-input"
                                    maxLength={4}
                                    onChange={onChange}
                                    name={name}
                                    value={value}
                                    placeholder="CVV"
                                    type={isShowCv ? 'text' : 'password'}
                                />
                            )}
                        />
                        <svg
                            onClick={({ target }) => {
                                setTsShowCvv(t => !t);
                            }}
                            className={`${isShowCv ? 'modal_credit-card__item-icon-shown' : ''
                                } modal_credit-card__item-icon`}
                            width="20"
                            height="20"
                            viewBox="0 0 1"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                        >
                            <path
                                fill-opacity="1"
                                fill="#000"
                                d="m1.829 10.632-.59.462.59-.462zm0-3.263.59.462-.59-.462zm15.342 3.263.59.462-.59-.462zm0-3.263.59-.463-.59.463zM18 9h.75H18zM2.246.477A.75.75 0 0 0 1.17 1.523L2.246.477zm14.508 17.046a.75.75 0 1 0 1.074-1.046l-1.074 1.046zm-4.075-2.013a.75.75 0 0 0-.658-1.348l.658 1.348zM3.902 6.144a.75.75 0 1 0-1.064-1.057l1.064 1.057zm4.95 5.993a.75.75 0 1 0 .31-1.467l-.31 1.467zm-.976-2.795a.75.75 0 0 0-1.471.29l1.471-.29zM9.5 14.796c-1.417 0-2.798-.644-4.049-1.58-1.244-.932-2.294-2.105-3.032-3.047l-1.18.925c.78.998 1.923 2.282 3.313 3.322 1.384 1.037 3.079 1.88 4.948 1.88v-1.5zm0-11.591c1.417 0 2.798.644 4.049 1.58 1.244.932 2.294 2.105 3.032 3.046l1.18-.925c-.78-.997-1.923-2.281-3.313-3.322-1.384-1.036-3.079-1.88-4.948-1.88v1.5zm-7.08 6.964c-.593-.756-.67-.9-.67-1.169H.25c0 .88.476 1.44.988 2.094l1.181-.925zM1.237 6.906C.726 7.561.25 8.121.25 9h1.5c0-.268.077-.412.67-1.169l-1.182-.925zm16.524 4.188c.512-.654.988-1.215.988-2.094h-1.5c0 .268-.077.413-.67 1.17l1.182.924zM16.58 7.831c.592.757.669.901.669 1.17h1.5c0-.88-.476-1.44-.989-2.095l-1.18.925zM9.5 7.296c.901 0 1.657.749 1.657 1.704h1.5c0-1.755-1.4-3.204-3.157-3.204v1.5zm2.521 6.866c-.817.398-1.663.634-2.521.634v1.5c1.136 0 2.208-.312 3.179-.786l-.658-1.348zM2.42 7.832c.404-.516.905-1.106 1.483-1.688L2.838 5.087a20.804 20.804 0 0 0-1.6 1.82l1.181.924zm2.929-2.968c1.276-.978 2.695-1.66 4.152-1.66v-1.5c-1.921 0-3.658.892-5.065 1.969l.913 1.19zM1.17 1.524l3.183 3.268L5.43 3.745 2.246.477 1.17 1.523zm12.4 12.732 3.183 3.267 1.074-1.046-3.182-3.268-1.075 1.047zm3.01-4.087c-.717.915-1.729 2.05-2.928 2.968l.912 1.19c1.336-1.023 2.437-2.263 3.197-3.233l-1.181-.925zM4.354 4.792l2.913 2.99L8.34 6.736 5.43 3.746 4.354 4.791zm3.984 2.994c.301-.306.711-.49 1.162-.49v-1.5c-.873 0-1.661.36-2.23.936l1.068 1.054zm-1.071-.004 3.392 3.483 1.074-1.046-3.392-3.483-1.074 1.046zm3.392 3.483 2.912 2.99 1.075-1.046-2.913-2.99-1.074 1.046zM11.157 9c0 .478-.19.907-.495 1.215l1.068 1.054c.573-.581.927-1.385.927-2.269h-1.5zm-1.994 1.67a1.685 1.685 0 0 1-1.287-1.328l-1.471.29a3.184 3.184 0 0 0 2.446 2.505l.312-1.467z"
                            />
                            <path
                                fill-opacity="1"
                                fill="#0296ff"
                                d="m1.829 10.591-.59.463.59-.463zm0-3.263.59.463-.59-.463zm15.342 3.263.59.463-.59-.463zm0-3.263.59-.462-.59.462zM18 8.96h.75H18zm-5.321 6.51a.75.75 0 0 0-.658-1.349l.658 1.348zM3.902 6.102a.75.75 0 1 0-1.064-1.057l1.064 1.057zm4.95 5.993a.75.75 0 1 0 .31-1.467l-.31 1.467zm-.976-2.795a.75.75 0 0 0-1.471.29l1.471-.29zM9.5 14.755c-1.417 0-2.798-.644-4.049-1.58-1.244-.932-2.294-2.105-3.032-3.047l-1.18.926c.78.997 1.923 2.281 3.313 3.322 1.384 1.036 3.079 1.88 4.948 1.88v-1.5zm0-11.591c1.417 0 2.798.644 4.049 1.58 1.244.932 2.294 2.105 3.032 3.047l1.18-.925c-.78-.998-1.923-2.282-3.313-3.322-1.384-1.037-3.079-1.88-4.948-1.88v1.5zm-7.08 6.964c-.593-.756-.67-.9-.67-1.168H.25c0 .879.476 1.44.988 2.094l1.181-.926zM1.237 6.866C.726 7.52.25 8.08.25 8.96h1.5c0-.268.077-.413.67-1.17l-1.182-.924zm16.524 4.188c.512-.655.988-1.215.988-2.094h-1.5c0 .268-.077.412-.67 1.168l1.182.926zM16.58 7.79c.592.756.669.9.669 1.169h1.5c0-.88-.476-1.44-.989-2.094l-1.18.925zM9.5 7.255c.901 0 1.657.75 1.657 1.705h1.5c0-1.756-1.4-3.205-3.157-3.205v1.5zm2.521 6.866c-.817.399-1.663.634-2.521.634v1.5c1.136 0 2.208-.312 3.179-.786l-.658-1.348zM2.42 7.791c.404-.516.905-1.106 1.483-1.688L2.838 5.046a20.804 20.804 0 0 0-1.6 1.82l1.181.925zm2.929-2.968c1.276-.978 2.695-1.66 4.152-1.66v-1.5c-1.921 0-3.658.892-5.065 1.97l.913 1.19zm-.994-.072L5.43 3.704 4.354 4.751zm9.217 9.464 1.075-1.047-1.075 1.047zm3.01-4.087c-.717.915-1.729 2.05-2.928 2.968l.912 1.191c1.336-1.024 2.437-2.264 3.197-3.233l-1.181-.926zM8.34 6.695 5.43 3.705l2.912 2.99zm-.003 1.05c.301-.306.711-.49 1.162-.49v-1.5c-.873 0-1.661.36-2.23.936l1.068 1.054zm3.395 2.433L8.341 6.695l3.392 3.483zm2.913 2.99-2.913-2.99 2.913 2.99zm-3.49-4.208c0 .477-.19.906-.494 1.214l1.068 1.054c.573-.58.927-1.385.927-2.268h-1.5zm-1.993 1.67A1.685 1.685 0 0 1 7.876 9.3l-1.471.29a3.184 3.184 0 0 0 2.446 2.505l.312-1.467z"
                            />
                        </svg>
                        {formState?.errors?.cvv?.message ? (
                            <p className="modal_credit-card__item-error">{formState?.errors?.cvv?.message}</p>
                        ) : null}
                    </label>
                </div>
                <div className="modal_credit-card__buttons">
                    {buttons.map(({ title, onClick, type }, index) => (
                        <Button options={{ type }} onClick={type === 'submit' ? handleFormSubmit : onClose} id={index}>
                            {type == 'submit' && isLoading ? 'Updating...' : title}
                        </Button>
                    ))}
                </div>
            </form>
        </div>
    );
};

export default withTranslation()(CardManagerModal);
